import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Alert, TextButton } from '@zillow/constellation';

import { UserSelectors } from 'app/shared/selectors';

import ModalActions from 'app/shared/actions/ModalActions';
import ModalConstants from 'app/shared/constants/ModalConstants';

const PendingEmailVerificationBox = ({ handleResendEmailClick }) => {
    const dispatch = useDispatch();

    const email = useSelector(state => UserSelectors.makeEmail(state));

    const showVerifyEmailModal = () => {
        dispatch(ModalActions.showModal({
            modalType: ModalConstants.VERIFY_EMAIL_MODAL,
            header: 'Listings found',
            handleResendEmailClick,
        }));
    };

    return (
        <Alert
            appearance="warning"
            body={`The listings associated with your account will be added once you verify your email at ${email}.`}
            actionButton={<TextButton onClick={showVerifyEmailModal}>View details</TextButton>}
        />
    );
};

export default PendingEmailVerificationBox;
